export default __webpack_public_path__ + "static/media/brand-icons.3c45c98f.svg";